<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.ssh') }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    <status-label :status="status"/>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav">
            <button @click="enableSsh" v-if="customerConfig.ssh === 'OFF'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.ssh-enable') }}
            </button>

            <button @click="disableSsh" v-if="customerConfig.ssh === 'ON'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.ssh-disable') }}
            </button>
        </div>
    </div>
</template>

<script>
import HostingApi from '../services/api/hosting.js';
import { EventBus } from "relapp-event/src/event";
import { StatusLabel } from "relapp-technical-management";

export default {
    components: {
        StatusLabel,
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        customerConfig: {
            type: Object,
            required: true
        }
    },
    methods: {
        enableSsh() {
            HostingApi.modifyCustomer(this.domain, { enableSsh: true })
                .then(response => {
                    this.customerConfig.ssh = 'ON';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },

        disableSsh() {
            HostingApi.modifyCustomer(this.domain, { enableSsh: false })
                .then(response => {
                    this.customerConfig.ssh = 'OFF';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },
    },
    computed: {
        /**
         * Status label.
         *
         * @return {string}
         */
        status() {
            if (this.customerConfig.ssh === 'ON') {
                return 'active';
            } else {
                return 'inactive';
            }
        }
    }
};
</script>
